import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "App";
import axiosInstance from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";
import { PayInvoiceParams, PayInvoiceResponse } from "types/PaymentTypes";

export const usePayInvoice = (
  options?: UseMutationOptions<PayInvoiceResponse, Error, PayInvoiceParams>,
) => {
  return useMutation({
    ...options,
    mutationKey: ["payInvoice"],
    mutationFn: async ({ invoice_uid }) => {
      const data: PayInvoiceResponse = await axiosInstance
        .post(`/payments/${invoice_uid}/pay`)
        .then((res) => res.data);

      if (data?.ok === false) {
        throw new Error(data?.message || "Your card was declined.");
      }

      return data;
    },
    onMutate: () => {
      Toast({
        message: "Próba pobrania płatności.",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "pay-invoice",
      });
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["payments"] });
      queryClient.invalidateQueries({ queryKey: ["customers"] });
      queryClient.invalidateQueries({ queryKey: ["subscriptions"] });
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ["me"] });
      }, 200);

      Toast({
        message: "Płatność przetworzona.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "pay-invoice",
      });

      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message:"Nie udało się ponowić płatności.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "pay-invoice",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default usePayInvoice;
